import React, { useState } from "react";
import { useSelector } from "react-redux";
// import { addStoreManager, addStore, addStoreStock } from "../../../redux/StoreManagement/storeManagementActions";
import {GroupAdd, AddBusiness} from "@mui/icons-material";
import AddStoreDrawer from "./AddStoreDrawer";
import AddStoreManagerDrawer from "./AddStoreManagerDrawer";


const QuickActions = () => {
  // const dispatch = useDispatch();
  const [showAddStoreDrawer, setShowAddStoreDrawer] = useState(false);
  const [showAddStoreManagerDrawer, setShowAddStoreManagerDrawer] = useState(false);
  
  const {
    addStoreManagerLoading,
    addStoreLoading,
  } = useSelector((state) => state.storeManagement);

  const handleAddStoreManager = () => {
    setShowAddStoreManagerDrawer(true);
  };

  const handleAddStore = () => {
    setShowAddStoreDrawer(true);
  };

  const actions = [
    {
      icon: <GroupAdd style={{ fontSize: "18px", color: "white" }} />,
      label: "Add Store Manager",
      action: handleAddStoreManager,
      loading: addStoreManagerLoading,
    },
    {
      icon: <AddBusiness style={{ fontSize: "18px", color: "white" }} />,
      label: "Add Store",
      action: handleAddStore,
      loading: addStoreLoading,
    },
  ];

  return (
    <div className="bg-white border border-[#E1E6E1] rounded-lg">
      <div className="border-b border-[#E1E6E1] p-4">
         <h6 className="text-[#5F6D60] font-semibold text-sm">Quick Actions</h6>
      </div>
      
      {/* Grid Layout - 2 columns for first row, 1 column centered for third item */}
      <div className="grid grid-cols-2 gap-4 py-4 px-4">
        {/* First two actions in top row */}
        {actions.slice(0, 2).map((action, index) => (
          <button
            key={index}
            onClick={action.action}
            disabled={action.loading}
            className="py-4 px-4 bg-[#F6F7F6] shadow-storeCard hover:bg-[#EDF7EE] rounded-lg transition duration-200 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed min-h-[80px] "
          >
            {/* Large circular green icon */}
            <div className="w-[32px] h-[32px] flex items-center justify-center bg-[#2B8C34] rounded-full mb-4">
              {action.icon}
            </div>
            
            {/* Label */}
            <p className="text-[#344335] text-left font-semibold text-sm leading-tight">
              {action.loading ? "Loading..." : action.label}
            </p>
          </button>
        ))}
  
      </div>

      {/* Add Store Drawer */}
      <AddStoreDrawer 
        showDrawer={showAddStoreDrawer}
        setShowDrawer={setShowAddStoreDrawer}
      />

      {/* Add Store Manager Drawer */}
      <AddStoreManagerDrawer 
        showDrawer={showAddStoreManagerDrawer}
        setShowDrawer={setShowAddStoreManagerDrawer}
      />
    </div>
  );
};

export default QuickActions;